import type { MenuConfig } from '~typings/menu'

import permisosInventario, { RESOURCE_INVENTARIO } from '@/auth/permissions/modules/inventario'
import * as names from '@routes/inventario-consumo/nombres/mantenimiento'

const { mantenimiento } = permisosInventario

export default [
    {
        title: 'inventario.subopciones.crear_tipo_bodega',
        route: names.ROUTE_INVENTARIOS,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.inventarios,
    },
    {
        title: 'inventario.subopciones.crear_bodega',
        route: names.ROUTE_BODEGA,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.bodega,
    },
    {
        title: 'inventario.subopciones.crear_categoria',
        route: names.ROUTE_CATEGORIA_BIEN,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.categoriaBien,
    },
    {
        title: 'inventario.subopciones.crear_linea',
        route: names.ROUTE_LINEAS_BIEN,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.lineasBien,
    },
    {
        title: 'inventario.subopciones.gestion_item',
        route: names.ROUTE_GESTION_ITEMS,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.gestionItems,
    },
    {
        title: 'inventario.subopciones.crear_marca',
        route: names.ROUTE_MARCAS,
        resource: RESOURCE_INVENTARIO,
        action: mantenimiento.marcas,
    },
] as MenuConfig[]
